export default {
      id: "bath-usage",
      viewBox: "0 0 512 512",
      url: __webpack_public_path__ + "svgs/icons.91fe9319.svg#bath",
      toString: function () {
        return this.url;
      }
    }